<template>
  <div :class="['model', type,theme]" :style="model" v-if="data.length !== 0">
    <div class="modelTitle" :style="{ backgroundColor: bColor, color: textColor }">{{ title }}</div>
    <div class="modelBg">
      <div class="list">
        <div class="item" v-for="(item, index) in data" :key="index" @click="toUrl(item)">
          <div class="itemImg">
            <img :src="item.img" />
            <div class="go-btn" v-if="item.linkType == 2 && item.linkUrl && item.linkOriginalId">
              <wx-open-launch-weapp :username="item.linkOriginalId" :path="item.linkUrl" @error="handleErrorFn" @launch="handleLaunchFn">
                <script type="text/wxtag-template">
                  <style>
                    .btn{
                      width: 150px;
                      height: 150px;
                    }
                  </style>
                  <div class="btn"></div>
                </script>
              </wx-open-launch-weapp>
            </div>
          </div>
          <div class="itemInfo">
            <div class="name">{{ item.name }}</div>
            <div class="info">{{ item.info }}</div>
            <div class="btn">
              <div :style="{ backgroundColor: bColor, color: textColor }" @click.stop="nav(item, 'nav')">
                <img src="https://assets.rurushishi.com/activies/activityCenter/turntableLottery/navIcon.png" />
                导航
              </div>

              <div :style="{ backgroundColor: bColor, color: textColor }" @click.stop="nav(item, 'tel')">
                <img src="https://assets.rurushishi.com/activies/activityCenter/turntableLottery/telIcon.png" />
                拨号
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import util from "@/utils/common";
import wx from "weixin-js-sdk";

export default {
  props: ["data", "bColor", "title", "textColor", "type",'theme','salePhone'],
  data() {
    return {
      iswx: false,
      isMiniApp: false,
      name: "1",
      info: "",
      longitude: "121.31296",
      latitude: "31.19402",
      telephoneNumber: "1",
      img: "https://assets-cos-test.yqaitech.com/marcloud/wx01f0b018d4951434/20211208964746591446.png",
      linkSwitch: 0,
      linkType: 1,
      linkUrl: "",
      linkOriginalId: "",
    };
  },
  created() {
    this.iswx = util.browser.versions.wx;
    let _this = this;
    console.log(wx);
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        _this.isMiniApp = true;
      } else {
        _this.isMiniApp = false;
      }
    });
  },
  computed: {
    model() {
      if (this.type == "lightup") {
        return { backgroundColor: `${this.bColor}80` };
      } else if (this.type == "purchase") {
        return {border:`none`,backgroundColor:'' }
      }
      if (this.theme == "theme2") {
        return {
          backgroundColor: this.$util.rgbToRgba(this.bColor, 0.5) ,
        };
      }
      return {
        borderColor: this.bColor,
      };
    },
  },
  methods: {
    handleErrorFn(e) {
      console.log("fail", e.detail);
    },
    handleLaunchFn(e) {
      console.log("success", e);
    },
    toUrl(item) {
      if (item.linkSwitch == 0) return;
      if (item.linkType == 1) {
        if (item.linkUrl.indexOf("http://") < 0 && item.linkUrl.indexOf("https://") < 0) window.location.href = "https://" + item.linkUrl;
        else {
          window.location.href = item.linkUrl;
        }
      }
      // if (!item.navLink) return;
      // if (
      //   item.navLink.indexOf("http://") < 0 &&
      //   item.navLink.indexOf("https://") < 0
      // )
      //   window.location.href = "https://" + item.navLink;
      // else {
      //   window.location.href = item.navLink;
      // }
    },
    nav(item, type) {
      if (type == "tel") {
        console.log(item)
        let phone=item.telephoneNumber
        if(item.contactSaleSwitch==1){
          phone=this.salePhone||item.telephoneNumber
        }
        window.location.href = `tel:${phone}`;
      }
      if (type == "nav") {
        window.location.href = `https://uri.amap.com/marker?position=${item.longitude},${item.latitude}&name=${item.address}&src=mypage&coordinate=gaode&callnative=0`;
      }
    },
    goAppUrl(link) {
      if (!link) {
        return false;
      }
      wx.miniProgram.navigateTo({
        url: `/${link}`,
        fail: function () {
          wx.miniProgram.switchTab({ url: `/${link}` });
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.model {
  width: 351px;
  margin: 50px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border: 5px solid  #fff;
  box-sizing: border-box;
  &.purchase{
    padding: 10px;
    margin: 25px auto 0;
    box-shadow: 0px 0px 12px rgba(172, 3, 40, 0.3);
    background:  rgba(255, 255, 255, 0.1);
    .modelTitle {
      margin-top:-10px;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      border-radius: 0px 0px 12px 12px;
    }
  }
  &.theme2{
    padding: 10px;
    border: none;
    margin: 25px auto 0;
    box-shadow: 0px 0px 12px rgba(172, 3, 40, 0.3);
    background: rgba(255, 255, 255, 0.1);
    .modelTitle {
      margin-top: -10px;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      border-radius: 0px 0px 12px 12px;
    }
  }

  .modelTitle {
    position: absolute;
    margin-top: -20px;
    color: white;
    padding: 0 20px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    border-radius: 6px;
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
  }

  .modelBg {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 7px;

    .list {
      width: 100%;
      padding: 20px 15px 3px;

      .item {
        display: flex;
        align-items: center;
        padding: 16px 0;
        border-bottom: 0.5px solid rgba(239, 19, 80, 0.2);

        .itemImg {
          position: relative;
          width: 120px;
          height: 120px;

          img {
            width: 120px;
            height: 120px;
            border-radius: 6px;
            object-fit: cover;
          }

          .go-btn {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }
        }

        .itemInfo {
          flex: 1;
          height: 120px;
          margin-left: 16px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
              width: 175px;

          .name {
            font-weight: 600;
            font-size: 16px;
            line-height: 22px;
            color: #262626;
            word-break: break-all;
          }

          .info {
            font-size: 12px;
            line-height: 17px;
            color: #595959;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            word-break: break-all;
          }

          .btn {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            img{
              width:10px;
              margin-right:7px;
            }

            div {
              width: 78px;
              height: 24px;
              font-weight: normal;
              font-size: 12px;
              line-height: 16px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #FFFFFF;
              border-radius: 12px;
            }
          }
        }
      }

      .item:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>
